import { render, staticRenderFns } from "./Pagebuilder.vue?vue&type=template&id=32ae8f13&"
import script from "./Pagebuilder.vue?vue&type=script&lang=ts&"
export * from "./Pagebuilder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports